import type { LegendItem } from '../../core/components/legend/categorical/types/legend.js';

export interface HoneycombSelectionState {
  hovered: LegendItem | undefined;
}

export interface HoneycombState {
  selection: HoneycombSelectionState;
}

export const initialState: HoneycombState = {
  selection: {
    hovered: undefined,
  },
};
